import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import {
    L10N_CONFIG,
    L10N_LOCALE,
    L10nConfig,
    L10nLocale,
    L10nTranslatePipe,
    L10nTranslationService
} from 'angular-l10n';

import { HttpClient } from "@angular/common/http";
import { FormsModule } from "@angular/forms";
import { FlexModule, MediaObserver } from "@ngbracket/ngx-layout";
import { APIConfigService } from "../../api.config.service";
import { AngularMaterial2Module } from "../../app.module.material";
import { AuthService } from "../../shared/auth.service";
import { BreadcrumbService } from "../../shared/breadcrumb/breadcrumb.service";
import { ErrorHelper } from "../../shared/error.helper";
import { LoggerService } from "../../shared/logger.service";
import { SessionService } from "../../shared/session.service";
import { UrlMaxLen } from "../../shared/url.model";
import { OaseDeleteDialogComponent } from "../immerdrin/oase.delete.component";
import { Tabelle } from "../immerdrin/tabelle/tabelle";
import { Kernrecht } from "../kernrecht/kernrecht.model";
import { KernnavigationInsertEditComponent } from "./kernnavigation.insertEdit.component";
import { Kernnavigation } from "./kernnavigation.model";

const PATH_FILE = 'app/protected/kernnavigation/kernnavigation.component.ts';
const OBJ_LNG_NAME = 'navigation';
const BACKEND_PATH_PREFIX = 'navigation/';

@Component({
    selector: 'oase-kernnavigation',
    templateUrl: './kernnavigation.component.html',
    standalone:true, imports: [AngularMaterial2Module, L10nTranslatePipe, FormsModule, FlexModule]

})
export class KernnavigationComponent extends Tabelle<Kernnavigation> {
    aktuellurlmax: UrlMaxLen = null;
    rechte: Kernrecht[] = new Array<Kernrecht>();
    zieltypen: string[] = ['_self', '_blank']; // Da ein Target mit routerLink nicht funktioniert habe ich jetzt nur _self gelassen
    aktuellicons: string[] = Array<string>();
    aktuelldelete: Kernnavigation = null;
    eltern: Kernnavigation[] = new Array<Kernnavigation>();

    constructor(
        public route: ActivatedRoute,
        public router: Router,
        public breadcrumbService: BreadcrumbService,
        public snackBar: MatSnackBar,
        public authService: AuthService,
        public apiConfigService: APIConfigService, public http: HttpClient,
		@Inject(L10N_LOCALE) public locale: L10nLocale,
		@Inject(L10N_CONFIG) private config: L10nConfig,
		public translation: L10nTranslationService,        // public dragulaService: DragulaService,
        public dialog: MatDialog,
		public media: MediaObserver,
        public changeDetectorRef: ChangeDetectorRef,
        public sessService: SessionService,
        public title: Title,
        public _logger: LoggerService) {

        super( route, router, breadcrumbService, snackBar,
            authService, http, translation, dialog, media, changeDetectorRef,
            sessService, title, _logger, apiConfigService, {
                OBJ_LNG_NAME: OBJ_LNG_NAME,
                BACKEND_PATH_PREFIX: BACKEND_PATH_PREFIX,
                ROUTE_NAME: "/kernbenutzer",
                PATH_FILE: PATH_FILE,
                DEFAULT_SORT_COLUMN: "treepath",
                extraDataForAdding: { }
            }
        );
        this.displayedColumns = ['treepath', 'icon', 'sprachschluessel', 'eltern', 'ziel', 'url', 'rechte', 'admin'];
    }

    extraInit() {
        this.getKernRechte();
        this.getEltern();
        super.extraInit();
    }

	getEbene(n: Kernnavigation) {
		return n.treePath.split(".").length - 1;
	}

	getTreePath(n: Kernnavigation) {
		return n.treePath.startsWith('0') ? n.treePath.substring(1,(n.treePath.length-1)) : n.treePath;
	}


	createNewElement() {
        return new Kernnavigation();
    }

    loeschenSpalteName() {
        return "md2DataTableSort_Sprachschluessel";
    }

    setDerivedColumns() {

        this.derivedColumns.push(
            {   key: "sprachschluessel",
                internalName: "md2DataTableSort_Sprachschluessel",
                f: (row: any) => { return this.translation.translate(row.sprachschluessel) }
            }
        )
    }

    getApiParams() {
        return "seite";
    }

    vorHinzufuegen(element) {
        element.passwort = null;
        element.rechte = this.rechte;
        element.passwortwiederholung = null;
        element.eltern = this.eltern;
        element.aktuellurlmax = new UrlMaxLen();
        element.aktuellurlmax.urlschema = 255;
        element.aktuellurlmax.host = 255;
        element.aktuellurlmax.pfad = 255;
        element.aktuellurlmax.query = 255;
        element.aktuellurlmax.fragment = 255;
        element.vater = null; // Damit keine Auswahl vorhanden ist
        element.recht = new Kernrecht();
        element.ziel = this.zieltypen[0];
        this.fuelleUrl(element);

    }

    zeigeLoeschenMaske(element: any) {
        this._zeigeLoeschenMaske(element, OaseDeleteDialogComponent);
    }

    zeigeHinzufuegenMaske() {
        this._zeigeHinzufuegenMaske(KernnavigationInsertEditComponent);
    }

    zeigeBearbeitenMaske(element) {
        element.rechte = this.rechte;
        element.eltern = this.eltern;
        element.vaterOrig = element.vater;
        element.aktuellurlmax = new UrlMaxLen();
        element.aktuellurlmax.urlschema = 255 - (element != null && element.urlschema != null ? element.urlschema.length + element.urlschema.length : 0);
        element.aktuellurlmax.host = 255 - (element != null && element.host != null ? element.host.length + element.host.length : 0);
        element.aktuellurlmax.pfad = 255 - (element != null && element.pfad != null ? element.pfad.length + element.pfad.length : 0);
        element.aktuellurlmax.query = 255 - (element != null && element.query != null ? element.query.length + element.query.length : 0);
        element.aktuellurlmax.fragment = 255 - (element != null && element.fragment != null ? element.fragment.length + element.fragment.length : 0);
        this.fuelleUrl(element);

        this._zeigeBearbeitenMaske(element, KernnavigationInsertEditComponent);
    }

    private getKernRechte() {
        this._logger.log(PATH_FILE + ' - getKernRechte Begin');

        this.ladedaten = true;

        this.http.get<Kernrecht[]>(this.apiConfigService.REST_API_BASE() + 'recht/liste').subscribe({
            next: (res) => {
                this.ladedaten = false;
                this.rechte = res;
            },
            error: (err) => {
                this.ladedaten = false;
                ErrorHelper.handleError(err,"Fehler beim holen die Rechte",this._logger, this.translation);
            },
            complete: () => {
                this.ladedaten = false;
                this._logger.log(PATH_FILE + ' - getKernRechte FERTIG');
                this._logger.log(PATH_FILE + ' - getKernRechte kerngruppen: ', this.rechte)
            }
        });
    }

    private getEltern() {
        this._logger.log(PATH_FILE + ' - getEltern Begin');

        this.ladedaten = true;

        this.http.get<Kernnavigation[]>(this.REST_API + '/liste/alle').subscribe({
            next: (res) => {
                this.ladedaten = false;
                this.eltern = res;
            },
            error: (err) => {
                this.ladedaten = false;
                ErrorHelper.handleError(err,"Fehler beim holen die Rechte",this._logger, this.translation);
            },
            complete: () => {
                this.ladedaten = false;
                this._logger.log(PATH_FILE + ' - getKernRechte FERTIG');
                this._logger.log(PATH_FILE + ' - getKernRechte kerngruppen: ', this.rechte)
            }
        });
    }

    // such comparison is needed for mat-select
    compareMitId(item1, item2) {
        return item1 && item2 ? item1.id === item2.id : item1 === item2;
    }

    behandleRechteaenderungen(element) {
        this._logger.log(PATH_FILE + ' - behandleRechteaenderungen BEGIN');
        this._logger.log(PATH_FILE + ' - behandleRechteaenderungen kernnavigation: ', element);

        let snacknachricht = this.translation.translate('allgemein.daten.geändert', { typ: this.translation.translate(OBJ_LNG_NAME+'.typ') });
        this.speichern(element, snacknachricht, false); // false ... Tabelle nicht neu laden
    } // behandleRechteaenderungen




    private fuelleUrl(element) {
        element.icon = element.icon ?? '';
        element.url = element.url ?? '';
        element.urlschema = element.urlschema ?? '';
        element.host = element.host ?? '';
        element.pfad = element.pfad ?? '';
        element.query = element.query ?? '';
        element.fragment = element.fragment ?? '';
    }

    createRange(number){
        let items: number[] = [];
        for(let i = 1; i <= number; i++)
            items.push(i);
        return items;
    }

}
